import validate from './ClubNonAthleteRosterFilterFormValidation';

import useForm from "@usas/ui-web/utils/UseForm";
import Constants from '@usas/ui-web/utils/Constants';

const INITIAL_FORM_STATE = {
  practiceGroupId: Constants.DEFAULT_ID,
  practiceGroupName: '',
  siteGroupId: Constants.DEFAULT_ID,
  siteGroupName: '',
  firstOrPreferredName: '',
  lastName: ''
};

const useClubNonAthleteRosterFilterForm = (onSubmitNonAthleteFilter, onClearNonAthleteFilter) => {
  const { formState, errorState, setFormData, updateFormState, onValueTextPairChanged, handleSubmit
  } = useForm(INITIAL_FORM_STATE, onSubmitNonAthleteFilter, validate);

  const onClearFilterClicked = (event) => {
    event?.preventDefault();

    setFormData(INITIAL_FORM_STATE);
    onClearNonAthleteFilter(event, INITIAL_FORM_STATE);
  };

  return {
    formState,
    errorState,
    onFormValueChanged: updateFormState,
    onValueTextPairChanged,
    handleSubmit,
    onClearFilterClicked
  };
};

export default useClubNonAthleteRosterFilterForm;